// Shared checkout runtime for editor preview and published storefronts.
// Backend loads this file via genre_dashboards/checkout_runtime.py

export default `
function snagcartCartKey() {
  return 'cart_' + (window.WEBSITE_ID || '');
}

function snagcartMigrateLegacyCart() {
  var key = snagcartCartKey();
  if (!window.WEBSITE_ID) return;
  try {
    var legacy = localStorage.getItem('snagcart_' + window.WEBSITE_ID);
    if (legacy && !localStorage.getItem(key)) {
      localStorage.setItem(key, legacy);
    }
  } catch (e) {}
}

function snagcartLoadCart() {
  snagcartMigrateLegacyCart();
  try {
    window.cart = JSON.parse(localStorage.getItem(snagcartCartKey()) || '[]');
  } catch (e) {
    window.cart = [];
  }
  if (!Array.isArray(window.cart)) window.cart = [];
}

function snagcartSaveCart() {
  try {
    localStorage.setItem(snagcartCartKey(), JSON.stringify(window.cart || []));
  } catch (e) {}
}

function snagcartCartTotal() {
  return (window.cart || []).reduce(function(sum, item) {
    return sum + Number(item.price || 0) * Number(item.quantity || item.qty || 1);
  }, 0);
}

function snagcartDetectCurrency() {
  if (window.PAYMENT_GATEWAYS && window.PAYMENT_GATEWAYS.currency) {
    return window.PAYMENT_GATEWAYS.currency;
  }
  if (window.STORE_CURRENCY) return window.STORE_CURRENCY;
  var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  if (tz.indexOf('Asia/Kolkata') >= 0 || tz.indexOf('Asia/Calcutta') >= 0) return 'INR';
  return 'USD';
}

function snagcartFormatErrorDetail(detail) {
  if (!detail) return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(function(entry) {
      if (typeof entry === 'string') return entry;
      return entry.msg || entry.message || JSON.stringify(entry);
    }).join(', ');
  }
  if (typeof detail === 'object') return detail.message || detail.msg || JSON.stringify(detail);
  return String(detail);
}

function snagcartCheckoutContext() {
  try {
    if (window.parent && window.parent !== window && String(window.parent.location.pathname || '').indexOf('/edit/') >= 0) {
      return 'editor';
    }
  } catch (e) {}
  return '';
}

function snagcartDefaultGateway() {
  var g = window.PAYMENT_GATEWAYS || {};
  var list = g.gateways || [];
  if (list.indexOf('razorpay') >= 0 && snagcartDetectCurrency() === 'INR') return 'razorpay';
  if (list.indexOf('stripe') >= 0) return 'stripe';
  if (list.indexOf('paypal') >= 0) return 'paypal';
  return list[0] || '';
}

function snagcartApiRoot() {
  var base = String(window.API_URL || '').replace(/\\/$/, '');
  if (!base) {
    try {
      if (window.parent && window.parent !== window && window.parent.location && window.parent.location.origin) {
        return window.parent.location.origin + '/api';
      }
    } catch (e) {}
    if (window.location && window.location.origin && window.location.origin !== 'null') {
      return window.location.origin + '/api';
    }
    return '/api';
  }
  if (base.slice(-4) === '/api') return base;
  return base + '/api';
}

async function snagcartFetchGateways() {
  if (window.PAYMENT_GATEWAYS && window.PAYMENT_GATEWAYS._loaded) return window.PAYMENT_GATEWAYS;
  if (!window.WEBSITE_ID) return { gateways: [], configured: false };
  try {
    var url = snagcartApiRoot() + '/payments/' + window.WEBSITE_ID + '/gateways';
    var resp = await fetch(url);
    if (!resp.ok) throw new Error('gateways unavailable');
    window.PAYMENT_GATEWAYS = await resp.json();
    window.PAYMENT_GATEWAYS._loaded = true;
  } catch (e) {
    window.PAYMENT_GATEWAYS = { gateways: [], configured: false, currency: snagcartDetectCurrency() };
  }
  return window.PAYMENT_GATEWAYS;
}

function snagcartCurrencySymbol(code) {
  return code === 'INR' ? '₹' : (window.CURRENCY_SYMBOL || '$');
}

function snagcartParseGooglePlace(place) {
  var components = place.address_components || [];
  function get(type) {
    for (var i = 0; i < components.length; i++) {
      if (components[i].types.indexOf(type) >= 0) return components[i].long_name;
    }
    return '';
  }
  var street = [get('street_number'), get('route')].filter(Boolean).join(' ');
  return {
    address1: street || place.name || '',
    city: get('locality') || get('postal_town') || get('administrative_area_level_2') || '',
    state: get('administrative_area_level_1') || '',
    postal_code: get('postal_code') || '',
    country: get('country') || '',
    formatted_address: place.formatted_address || '',
    place_id: place.place_id || '',
    lat: place.geometry && place.geometry.location ? place.geometry.location.lat() : null,
    lng: place.geometry && place.geometry.location ? place.geometry.location.lng() : null,
  };
}

async function snagcartFetchDeliveryConfig() {
  if (window._snagcartDeliveryConfig) return window._snagcartDeliveryConfig;
  if (!window.WEBSITE_ID) {
    window._snagcartDeliveryConfig = { delivery_enabled: false };
    return window._snagcartDeliveryConfig;
  }
  try {
    var resp = await fetch(snagcartApiRoot() + '/storefront/' + window.WEBSITE_ID + '/commerce/delivery-config');
    if (resp.ok) {
      window._snagcartDeliveryConfig = await resp.json();
      return window._snagcartDeliveryConfig;
    }
  } catch (e) {}
  window._snagcartDeliveryConfig = { delivery_enabled: false };
  return window._snagcartDeliveryConfig;
}

async function snagcartInitCheckoutAddressAutocomplete(apiKey, preferredInputId) {
  var input = null;
  if (preferredInputId) input = document.getElementById(preferredInputId);
  if (!input) input = document.getElementById('checkout-delivery-address');
  if (!input) input = document.getElementById('checkout-address');
  if (!input) return;
  if (!apiKey) {
    snagcartInitManualDeliveryAddress(input.id);
    return;
  }
  if (!window.google || !window.google.maps || !window.google.maps.places) {
    await snagcartLoadScript('https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=places');
  }
  if (!window.google || !window.google.maps || !window.google.maps.places) {
    snagcartInitManualDeliveryAddress(input.id);
    return;
  }
  var ac = new window.google.maps.places.Autocomplete(input, { types: ['address'] });
  ac.addListener('place_changed', function() {
    var place = ac.getPlace();
    if (!place || !place.geometry) return;
    window.snagcartShippingAddress = snagcartParseGooglePlace(place);
    window.snagcartFulfillmentType = 'local_delivery';
    var hint = document.getElementById('checkout-address-hint');
    if (hint) hint.textContent = window.snagcartShippingAddress.formatted_address || 'Address selected';
  });
}

function snagcartSyncManualDeliveryAddress(input) {
  if (!input) return;
  var line = String(input.value || '').trim();
  if (!line) {
    window.snagcartShippingAddress = null;
    return;
  }
  window.snagcartFulfillmentType = 'local_delivery';
  window.snagcartShippingAddress = {
    address1: line,
    formatted_address: line,
    city: '',
    state: '',
    postal_code: '',
    country: '',
  };
  var hint = document.getElementById('checkout-address-hint');
  if (hint) hint.textContent = line;
}

function snagcartInitManualDeliveryAddress(inputId) {
  var input = document.getElementById(inputId || 'checkout-delivery-address');
  if (!input || input.dataset.manualDeliveryBound === 'true') return;
  input.dataset.manualDeliveryBound = 'true';
  var sync = function() { snagcartSyncManualDeliveryAddress(input); };
  input.addEventListener('input', sync);
  input.addEventListener('blur', sync);
  var hint = document.getElementById('checkout-address-hint');
  if (hint) {
    hint.textContent = 'Type your full delivery address (street, city, ZIP). We geocode it for live tracking.';
  }
  sync();
}

function snagcartToggleFulfillment(type) {
  window.snagcartFulfillmentType = type;
  var block = document.getElementById('checkout-delivery-block');
  if (block) block.style.display = type === 'local_delivery' ? 'block' : 'none';
  var shipBlock = document.getElementById('checkout-shipping-block');
  if (shipBlock) shipBlock.style.display = type === 'local_delivery' ? 'none' : 'block';
  var shipBtn = document.getElementById('fulfillment-shipping');
  var delBtn = document.getElementById('fulfillment-delivery');
  if (shipBtn && delBtn) {
    var active = '2px solid var(--primary-color,#6366f1)';
    var idle = '2px solid #ddd';
    shipBtn.style.border = type === 'shipping' ? active : idle;
    shipBtn.style.background = type === 'shipping' ? 'rgba(99,102,241,0.08)' : 'white';
    delBtn.style.border = type === 'local_delivery' ? active : idle;
    delBtn.style.background = type === 'local_delivery' ? 'rgba(99,102,241,0.08)' : 'white';
  }
}

function snagcartProceedToCheckout() {
  snagcartLoadCart();
  if (!window.cart.length) {
    snagcartNotify('Your cart is empty');
    return;
  }
  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: 'switchEditorPage', slug: 'checkout' }, '*');
      return;
    }
  } catch (e) {}
  if (window.location && String(window.location.search || '').indexOf('page=checkout') < 0) {
    window.location.href = '?page=checkout';
  } else if (typeof snagcartInitCheckoutPage === 'function') {
    snagcartInitCheckoutPage();
  }
}

function snagcartBuildShippingAddress() {
  if (window.snagcartFulfillmentType === 'local_delivery') {
    if (window.snagcartShippingAddress && window.snagcartShippingAddress.address1) {
      return window.snagcartShippingAddress;
    }
    var delInput = document.getElementById('checkout-delivery-address') || document.getElementById('checkout-address');
    if (delInput) snagcartSyncManualDeliveryAddress(delInput);
    if (window.snagcartShippingAddress && window.snagcartShippingAddress.address1) {
      return window.snagcartShippingAddress;
    }
    return null;
  }
  var address = document.getElementById('address');
  if (!address) return null;
  var firstName = (document.getElementById('first-name') || {}).value || '';
  var lastName = (document.getElementById('last-name') || {}).value || '';
  var city = (document.getElementById('city') || {}).value || '';
  var state = (document.getElementById('state') || {}).value || '';
  var zip = (document.getElementById('zip') || {}).value || '';
  var line1 = (address.value || '').trim();
  if (!line1) return null;
  return {
    first_name: firstName,
    last_name: lastName,
    address1: line1,
    address2: (document.getElementById('address2') || {}).value || '',
    city: city,
    state: state,
    postal_code: zip,
    country: 'US',
    phone: (document.getElementById('phone') || {}).value || '',
  };
}

function snagcartCollectCheckoutPayload() {
  var emailEl = document.getElementById('checkout-email') || document.getElementById('email');
  var nameEl = document.getElementById('checkout-name');
  var firstNameEl = document.getElementById('first-name');
  var lastNameEl = document.getElementById('last-name');
  var email = emailEl ? String(emailEl.value || '').trim() : '';
  var name = nameEl ? String(nameEl.value || '').trim() : '';
  if (!name && firstNameEl) {
    name = [firstNameEl.value, (lastNameEl || {}).value].filter(Boolean).join(' ').trim();
  }
  return {
    customer_email: email,
    customer_name: name,
    gateway: window.selectedPaymentMethod || snagcartDefaultGateway(),
    fulfillment_type: window.snagcartFulfillmentType || 'shipping',
    shipping_address: snagcartBuildShippingAddress(),
    checkout_context: snagcartCheckoutContext(),
    items: (window.cart || []).map(function(item) {
      return {
        product_id: item.product_id || item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity || item.qty || 1,
      };
    }),
  };
}

async function snagcartSubmitCheckoutPayment(options) {
  options = options || {};
  var errEl = document.getElementById('checkout-error');
  if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }
  var payload = snagcartCollectCheckoutPayload();
  if (!payload.customer_email) {
    snagcartNotify('Please enter your email');
    var emailInput = document.getElementById('checkout-email') || document.getElementById('email');
    if (emailInput) emailInput.focus();
    return;
  }
  if (payload.fulfillment_type === 'local_delivery') {
    var localAddr = payload.shipping_address;
    if (!localAddr || !localAddr.address1) {
      snagcartNotify('Enter your delivery address (Google suggestion or full typed address)');
      return;
    }
  } else if (payload.fulfillment_type !== 'local_delivery') {
    var ship = payload.shipping_address;
    if (!ship || !ship.address1 || !ship.city || !ship.state || !ship.postal_code) {
      snagcartNotify('Please fill in your shipping address');
      return;
    }
  }
  if (!payload.items.length) {
    snagcartNotify('Your cart is empty');
    return;
  }

  await snagcartFetchGateways();
  var gateways = window.PAYMENT_GATEWAYS || {};
  if (!gateways.configured || !(gateways.gateways || []).length) {
    snagcartNotify('Payments are not configured yet. Add Stripe or Razorpay in Operate → Integrations → Payments.');
    return;
  }
  if (!payload.gateway) payload.gateway = snagcartDefaultGateway();

  var btn = options.buttonEl || document.getElementById('pay-btn') || document.getElementById('place-order-btn');
  var btnLabel = options.processingLabel || 'Processing...';
  var idleLabel = options.idleLabel || 'Pay securely';
  if (btn) { btn.textContent = btnLabel; btn.disabled = true; }

  try {
    var api = snagcartApiRoot();
    var resp = await fetch(api + '/payments/' + window.WEBSITE_ID + '/checkout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    var data = await resp.json().catch(function() { return {}; });
    if (!resp.ok) throw new Error(snagcartFormatErrorDetail(data.detail) || 'Checkout failed');

    if (data.gateway === 'stripe' && data.checkout_url) {
      window.location.href = data.checkout_url;
      return;
    }
    if (data.gateway === 'paypal' && data.checkout_url) {
      window.location.href = data.checkout_url;
      return;
    }
    if (data.gateway === 'razorpay' && data.order_id) {
      if (!window.Razorpay) await snagcartLoadScript('https://checkout.razorpay.com/v1/checkout.js');
      var optionsRzp = {
        key: data.key_id,
        amount: data.amount,
        currency: data.currency,
        order_id: data.order_id,
        name: window.WEBSITE_NAME || 'Store',
        description: 'Order ' + (data.order_number || ''),
        prefill: { name: payload.customer_name, email: payload.customer_email },
        handler: async function(response) {
          var verifyResp = await fetch(api + '/payments/razorpay/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              website_id: window.WEBSITE_ID,
              gateway: 'razorpay',
              payment_id: response.razorpay_payment_id,
              order_id: response.razorpay_order_id,
              signature: response.razorpay_signature,
            }),
          });
          var verifyData = await verifyResp.json().catch(function() { return {}; });
          if (!verifyResp.ok) throw new Error(verifyData.detail || 'Verification failed');
          window.cart = [];
          snagcartSaveCart();
          document.getElementById('checkout-modal')?.remove();
          snagcartNotify('Payment successful!');
          if (data.tracking_url) {
            try { localStorage.setItem('last_tracking_url_' + window.WEBSITE_ID, data.tracking_url); } catch (e) {}
            snagcartNotify('Track delivery: ' + data.tracking_url);
          }
          if (typeof updateCartUI === 'function') updateCartUI();
          try {
            window.parent.postMessage({ type: 'switchEditorPage', slug: 'order-confirmation', orderId: data.order_id || '' }, '*');
          } catch (e) {}
          if (data.order_id) window.location.href = '?page=order-confirmation&order_id=' + encodeURIComponent(data.order_id);
        },
      };
      new window.Razorpay(optionsRzp).open();
      if (btn) { btn.disabled = false; btn.textContent = idleLabel; }
      return;
    }
    throw new Error('Unsupported gateway response');
  } catch (e) {
    snagcartNotify((e && e.message) ? e.message : 'Payment failed');
    if (btn) { btn.disabled = false; btn.textContent = idleLabel; }
  }
}

async function snagcartInitCheckoutPage() {
  if (!document.getElementById('checkout-items') && !document.getElementById('place-order-btn')) return;
  snagcartLoadCart();
  if (!window.cart.length) {
    snagcartNotify('Your cart is empty');
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: 'switchEditorPage', slug: 'cart' }, '*');
      }
    } catch (e) {}
    return;
  }

  await snagcartFetchGateways();
  var sym = snagcartCurrencySymbol(snagcartDetectCurrency());
  var subtotal = snagcartCartTotal();
  var tax = subtotal * 0.08;
  var delivery = subtotal >= 50 ? 0 : (subtotal > 0 ? 4.99 : 0);
  var total = subtotal + tax + delivery;
  var itemsEl = document.getElementById('checkout-items');
  if (itemsEl) {
    itemsEl.innerHTML = window.cart.map(function(item) {
      var qty = item.quantity || item.qty || 1;
      var line = (Number(item.price || 0) * qty).toFixed(2);
      return '<div style="display:flex;align-items:center;gap:.75rem;"><div style="width:48px;height:48px;background:#f1f5f9;border-radius:6px;display:flex;align-items:center;justify-content:center;">🛍️</div><div style="flex:1;min-width:0;"><div style="font-size:.85rem;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + (item.name || '') + '</div><div style="font-size:.8rem;color:#64748b;">Qty: ' + qty + '</div></div><div style="font-size:.875rem;font-weight:700;color:#16a34a;flex-shrink:0;">' + sym + line + '</div></div>';
    }).join('');
  }
  var setText = function(id, val) { var el = document.getElementById(id); if (el) el.textContent = sym + val; };
  setText('co-subtotal', subtotal.toFixed(2));
  setText('co-tax', tax.toFixed(2));
  setText('co-total', total.toFixed(2));
  var orderTotal = document.getElementById('order-total');
  if (orderTotal) orderTotal.textContent = sym + total.toFixed(2);
  var delEl = document.getElementById('co-delivery');
  if (delEl) delEl.textContent = delivery === 0 && subtotal > 0 ? 'Free 🎉' : (subtotal === 0 ? 'Free' : sym + delivery.toFixed(2));

  window.snagcartFulfillmentType = 'shipping';
  window.snagcartShippingAddress = null;
  var deliveryCfg = await snagcartFetchDeliveryConfig();
  var fulfillmentBlock = document.getElementById('checkout-fulfillment-block');
  if (fulfillmentBlock) {
    fulfillmentBlock.style.display = deliveryCfg.delivery_enabled ? 'block' : 'none';
  }
  if (deliveryCfg.delivery_enabled) {
    snagcartToggleFulfillment('shipping');
    await snagcartInitCheckoutAddressAutocomplete(
      deliveryCfg.google_maps_api_key || '',
      'checkout-delivery-address'
    );
  }

  window.placeOrder = function() {
    snagcartSubmitCheckoutPayment({
      buttonEl: document.getElementById('place-order-btn'),
      processingLabel: 'Processing…',
      idleLabel: '🔒 Place Order — ' + (document.getElementById('order-total') ? document.getElementById('order-total').textContent : ''),
    });
  };
  window.selectedPaymentMethod = snagcartDefaultGateway();
}

function snagcartNotify(msg) {
  var errEl = document.getElementById('checkout-error');
  if (errEl) {
    errEl.textContent = msg;
    errEl.style.display = 'block';
    try { errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
  }
  if (typeof showNotification === 'function') {
    showNotification(msg);
    return;
  }
  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: 'checkoutNotice', message: msg }, '*');
      return;
    }
  } catch (e) {}
  var toast = document.createElement('div');
  toast.textContent = msg;
  toast.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#dc2626;color:#fff;padding:12px 20px;border-radius:10px;z-index:100000;max-width:min(90%,420px);box-shadow:0 4px 20px rgba(0,0,0,.2);font-size:14px;line-height:1.4;';
  document.body.appendChild(toast);
  setTimeout(function() { toast.remove(); }, 5000);
}

async function snagcartStartCheckout() {
  snagcartLoadCart();
  if (!window.cart.length) {
    snagcartNotify('Your cart is empty');
    return;
  }
  await snagcartFetchGateways();
  var deliveryCfg = await snagcartFetchDeliveryConfig();
  window.snagcartFulfillmentType = 'shipping';
  window.snagcartShippingAddress = null;
  var gateways = window.PAYMENT_GATEWAYS || {};
  if (!gateways.configured || !(gateways.gateways || []).length) {
    snagcartNotify('Payments are not configured yet. Add Stripe or Razorpay in Operate → Integrations → Payments.');
    return;
  }

  var total = snagcartCartTotal();
  var currency = snagcartDetectCurrency();
  var sym = snagcartCurrencySymbol(currency);
  window.selectedPaymentMethod = snagcartDefaultGateway();

  var existing = document.getElementById('checkout-modal');
  if (existing) existing.remove();

  var modal = document.createElement('div');
  modal.id = 'checkout-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:10001;display:flex;align-items:center;justify-content:center;';
  var stripeBtn = (gateways.gateways || []).indexOf('stripe') >= 0
    ? '<button type="button" onclick="snagcartSelectPaymentMethod(\\'stripe\\')" class="payment-method-btn" data-method="stripe" style="flex:1;padding:15px;border:2px solid #ddd;border-radius:10px;background:white;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;"><span style="font-size:1.5rem;">💳</span><span>Card (Stripe)</span></button>'
    : '';
  var razorpayBtn = (gateways.gateways || []).indexOf('razorpay') >= 0
    ? '<button type="button" onclick="snagcartSelectPaymentMethod(\\'razorpay\\')" class="payment-method-btn" data-method="razorpay" style="flex:1;padding:15px;border:2px solid #ddd;border-radius:10px;background:white;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;"><span style="font-size:1.5rem;">🇮🇳</span><span>Razorpay</span></button>'
    : '';
  var paypalBtn = (gateways.gateways || []).indexOf('paypal') >= 0
    ? '<button type="button" onclick="snagcartSelectPaymentMethod(\\'paypal\\')" class="payment-method-btn" data-method="paypal" style="flex:1;padding:15px;border:2px solid #ddd;border-radius:10px;background:white;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;"><span style="font-size:1.5rem;">🅿️</span><span>PayPal</span></button>'
    : '';

  var deliveryBlock = '';
  if (deliveryCfg.delivery_enabled) {
    deliveryBlock = '<div style="margin-bottom:16px;">'
      + '<label style="display:block;margin-bottom:8px;font-weight:500;">Fulfillment</label>'
      + '<div style="display:flex;gap:8px;margin-bottom:12px;">'
      + '<button type="button" id="fulfillment-shipping" onclick="snagcartToggleFulfillment(\\'shipping\\')" style="flex:1;padding:10px;border:2px solid var(--primary-color,#6366f1);border-radius:8px;background:rgba(99,102,241,0.08);cursor:pointer;">Ship</button>'
      + '<button type="button" id="fulfillment-delivery" onclick="snagcartToggleFulfillment(\\'local_delivery\\')" style="flex:1;padding:10px;border:2px solid #ddd;border-radius:8px;background:white;cursor:pointer;">Local delivery</button>'
      + '</div>'
      + '<div id="checkout-delivery-block" style="display:none;">'
      + '<label style="display:block;margin-bottom:8px;font-weight:500;">Delivery address</label>'
      + '<input type="text" id="checkout-address" placeholder="Search your address on Google Maps" style="width:100%;padding:12px;border:1px solid #ddd;border-radius:8px;margin-bottom:6px;" autocomplete="off">'
      + '<p id="checkout-address-hint" style="font-size:0.8rem;color:#666;margin:0;">Pick an address from Google suggestions — location syncs automatically.</p>'
      + '</div></div>';
  }

  modal.innerHTML = '<div style="background:white;border-radius:20px;max-width:500px;width:90%;padding:40px;max-height:90vh;overflow-y:auto;">'
    + '<h2 style="margin-bottom:20px;font-size:1.5rem;">Checkout</h2>'
    + '<p style="font-size:0.9rem;color:#666;">Order Total</p>'
    + '<p style="font-size:2rem;font-weight:bold;color:var(--primary-color,#6366f1);margin-bottom:20px;">' + sym + total.toFixed(2) + '</p>'
    + '<label style="display:block;margin-bottom:8px;font-weight:500;">Email</label>'
    + '<input type="email" id="checkout-email" placeholder="you@example.com" style="width:100%;padding:12px;border:1px solid #ddd;border-radius:8px;margin-bottom:16px;" required>'
    + '<label style="display:block;margin-bottom:8px;font-weight:500;">Name</label>'
    + '<input type="text" id="checkout-name" placeholder="Your name" style="width:100%;padding:12px;border:1px solid #ddd;border-radius:8px;margin-bottom:16px;">'
    + deliveryBlock
    + '<div style="display:flex;gap:10px;margin-bottom:20px;flex-wrap:wrap;">' + stripeBtn + razorpayBtn + paypalBtn + '</div>'
    + '<button type="button" id="pay-btn" onclick="snagcartProcessPayment()" style="width:100%;padding:15px;background:var(--primary-color,#6366f1);color:white;border:none;border-radius:10px;font-weight:600;cursor:pointer;">Pay securely</button>'
    + '<button type="button" onclick="document.getElementById(\\'checkout-modal\\').remove()" style="width:100%;padding:12px;background:transparent;border:none;color:#666;margin-top:10px;cursor:pointer;">Cancel</button>'
    + '</div>';
  document.body.appendChild(modal);
  snagcartSelectPaymentMethod(window.selectedPaymentMethod);
  if (deliveryCfg.delivery_enabled) {
    await snagcartInitCheckoutAddressAutocomplete(
      deliveryCfg.google_maps_api_key || '',
      'checkout-address'
    );
  }
}

function snagcartSelectPaymentMethod(method) {
  window.selectedPaymentMethod = method;
  document.querySelectorAll('.payment-method-btn').forEach(function(btn) {
    var active = btn.getAttribute('data-method') === method;
    btn.style.borderColor = active ? 'var(--primary-color,#6366f1)' : '#ddd';
    btn.style.background = active ? 'rgba(99,102,241,0.08)' : 'white';
  });
}

async function snagcartLoadScript(src) {
  return new Promise(function(resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

async function snagcartProcessPayment() {
  await snagcartSubmitCheckoutPayment({
    buttonEl: document.getElementById('pay-btn'),
    processingLabel: 'Processing...',
    idleLabel: 'Pay securely',
  });
}

function snagcartBindCheckoutTriggers() {
  document.querySelectorAll('[data-snagcart-checkout], .cart-sidebar [data-snagcart-checkout]').forEach(function(el) {
    if (el.dataset.snagcartCheckoutBound === 'true') return;
    el.dataset.snagcartCheckoutBound = 'true';
    el.addEventListener('click', function(e) {
      e.preventDefault();
      snagcartStartCheckout();
    });
  });
  document.querySelectorAll('[data-snagcart-proceed-checkout], a[href*="?page=checkout"], a[href*="&page=checkout"]').forEach(function(el) {
    if (el.dataset.snagcartProceedBound === 'true') return;
    el.dataset.snagcartProceedBound = 'true';
    el.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      snagcartProceedToCheckout();
    });
  });
}

window.addEventListener('message', function(event) {
  if (!event.data || event.data.type !== 'snagcartOpenQuickCheckout') return;
  if (typeof snagcartStartCheckout === 'function') snagcartStartCheckout();
});

function snagcartInitCheckout() {
  snagcartLoadCart();
  snagcartBindCheckoutTriggers();
  snagcartInitCheckoutPage();
  window.startCheckout = snagcartStartCheckout;
  window.processPayment = snagcartProcessPayment;
  window.selectPaymentMethod = snagcartSelectPaymentMethod;
  window.snagcartToggleFulfillment = snagcartToggleFulfillment;
  window.snagcartProceedToCheckout = snagcartProceedToCheckout;
  window.openCheckout = snagcartProceedToCheckout;
  window.checkout = snagcartStartCheckout;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', snagcartInitCheckout);
} else {
  snagcartInitCheckout();
}
`;
